import axios from "axios";
import { API_URL } from "../../constants";

export const GetClientApproaches = async (userId,ApiStatus) => {
    ApiStatus({ isLoader: true, isError: false, data: null });
    const token = sessionStorage.getItem('LOGIN_TOKEN');
    try {
        let res = await axios.get(API_URL + "follow/followers/"+userId, {
            headers: {
                'Authorization': "Bearer " + token,
            }
        });
        ApiStatus({ isLoader: false, isError: false, data: res.data });
    } catch (err) {
        ApiStatus({ isLoader: false, isError: true, data: null });
    }

}